import React from 'react';
import PropTypes from 'prop-types';

class TextArea extends React.Component {
    componentDidMount() {
        if (this.props.isFocused) {
            this.inputRef.focus();
        }

        if (this.props.isRequired) {
            this.inputRef.required = true;
        }
    }

    render() {
        let Ref = (el) => (this.inputRef = el);
        const maxLength = this.props.maxLength || "";

        return (
            <div className="mb-3">
                <span className={(this.props.label) ? "has-float-label" : ""}>
                    <textarea
                        rows={this.props.rows}
                        className={`form-control${this.props.isValid === false ? " is-invalid" : ""}`}
                        id={this.props.name}
                        name={this.props.name}
                        placeholder={this.props.placeholder}
                        value={this.props.value}
                        onChange={this.props.onChange}
                        onFocus={this.props.onFocus}
                        onBlur={this.props.onBlur}
                        onKeyUp={this.props.onKeyUp}
                        disabled={this.props.isDisabled}
                        ref={Ref}
                        maxLength={maxLength}
                        autoComplete="off"
                    ></textarea>
                    {this.props.label &&
                        <label htmlFor={this.props.name}>{this.props.label}</label>                    
                    }
                    {this.props.errorMessage && (
                        <div className="invalid-feedback">{this.props.errorMessage}</div>
                    )}
                </span>
            </div>
        );
    }
}

TextArea.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    rows: PropTypes.number.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyUp: PropTypes.func,
    isRequired: PropTypes.bool,
    isFocused: PropTypes.bool,
    isValid: PropTypes.bool,
    isDisabled: PropTypes.bool,
    maxLength: PropTypes.number,
};

export default TextArea;
